// Tras cada publicación en Vercel, los JS de la versión anterior dan 404
// (31-10-2026: 404 en Movies-BtuEKuE0.js una hora después). Quien tenía la web
// abierta, o la abrió justo durante el cambio, veía «Algo ha ido mal» al ir a
// la primera pantalla que se carga aparte (cartelera, cines…). En ese caso se
// recarga la página una vez, que ya trae la versión nueva. Si vuelve a fallar
// en menos de 30 s, no se recarga más: se enseña el error de siempre.

const KEY = "rc-chunk-reload";
const WINDOW_MS = 30_000;

export function isChunkLoadError(error: unknown): boolean {
  const msg = error instanceof Error ? `${error.name} ${error.message}` : String(error ?? "");
  return /dynamically imported module|Importing a module script failed|error loading dynamically|Loading chunk|ChunkLoadError|Unable to preload CSS/i.test(msg);
}

/** Recarga la página si no se ha hecho ya hace poco. Devuelve si recarga. */
export function reloadForNewVersion(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* sin sessionStorage: se recarga igual (como mucho, una vez por carga) */
  }
  window.location.reload();
  return true;
}

export function installChunkReload(): void {
  // Vite avisa así cuando falla la precarga de un import dinámico.
  window.addEventListener("vite:preloadError", (e) => {
    if (reloadForNewVersion()) e.preventDefault();
  });
  window.addEventListener("unhandledrejection", (e) => {
    if (isChunkLoadError(e.reason)) reloadForNewVersion();
  });
}
